import { type Database } from "@fitness-app/supabase";

import { type BunnyVideoObject } from "../external/Bunny";

export type MediaLibraryEntity = Database["public"]["Tables"]["media_library"]["Row"];

export enum VideoUploadStatus {
  Pending = "pending",
  Queued = "queued",
  Processing = "processing",
  Encoding = "encoding",
  Ready = "ready",
  Failed = "failed",
}

export enum MediaLibraryType {
  Video = "video",
}

export enum MediaLibraryResourceType {
  Marketing = "marketing",
  Exercise = "exercise",
  /** TRE-1654 — recordings played inside a challenge event (live workout replays, Q&A). */
  Challenge = "challenge",
  /** TRE-1856 — videos embedded in a product resource. */
  ProductResource = "product_resource",
  /** TRE-1975 — long recordings uploaded as raw material for the clip pipeline. */
  StudioSource = "studio_source",
  /** TRE-1975 — rendered clips produced by Content Studio; kept out of the exercise library. */
  StudioClip = "studio_clip",
}

export interface MediaLibraryVideoData extends BunnyVideoObject {
  uploadStatus: VideoUploadStatus;
  type: "bunny";
  thumbnails: string[];
  authorizationSignature: string;
  authorizationExpire: number;
  dashUrl: string | null;
  hlsUrl: string | null;
  mp4Url: string | null;
  thumbnailUrl: string | null;
  previewUrl: string | null;
}

export interface MediaLibraryVideo extends Omit<MediaLibraryEntity, "data"> {
  type: MediaLibraryType.Video;
  resourceType: MediaLibraryResourceType;
  data: MediaLibraryVideoData;
}

export type MediaLibraryItem = MediaLibraryVideo;
export type MediaLibraryItemWithLinkedExercise = MediaLibraryItem & { exercises: { id: string; name: string }[] };
